var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseFormInputSkeleton v-input base-form-input-skeleton"},[_c('div',{staticClass:"v-input__control"},[_c('div',{staticClass:"v-input__slot placeholder-loading"}),_c('div',{staticClass:"v-text-field__details"})])])
}]

export { render, staticRenderFns }